<cui-sidenav productLogoSrc="assets/cui/logo/cicero-move-white.svg">

  <cui-sidenav-info>
    <mat-icon svgIcon="login-14x"></mat-icon>
    <span>{{user.name}}</span>
  </cui-sidenav-info>

  <mat-nav-list>
    <a mat-list-item class="search-pickuplist" routerLinkActive="active" [routerLink]="'/agency/' + user.agency.ISIL + '/pick-up-list/search'">
      <mat-icon svgIcon="nav/pickup-list"></mat-icon>
      Pluklister
    </a>

    <a mat-list-item class="search-materials" routerLinkActive="active" [routerLink]="'/agency/' + user.agency.ISIL + '/materials/search'">
      <mat-icon svgIcon="nav/materials"></mat-icon>
      Søg materialer
    </a>

    <a mat-list-item class="help" routerLinkActive="active" [routerLink]="'/agency/' + user.agency.ISIL + '/help'">
      <mat-icon svgIcon="nav/help"></mat-icon>
      Hjælp
    </a>

    <a mat-list-item class="logout" (click)="logout()">
      <mat-icon svgIcon="nav/log-out"></mat-icon>
      Log ud
    </a>
  </mat-nav-list>
  <a class="cookieRef" href="/move/assets/static/cookiesDanish.html">Cookies</a>

</cui-sidenav>



// WEBPACK FOOTER //
// ./src/app/navigation/sidenav/sidenav.component.html